import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  //declare properties
  user: any;

  //inject services
  constructor(private router: Router, private auth: AuthenticationService) {
    //setup a listener for login status
    this.auth.loginStatusChange.subscribe(data => {
      this.user = data;
    });
  }

  //initialize the component
  ngOnInit() {

  }

  //logs in the user
  login() {
    this.auth.login();
  }

  //take the user to the dashboard
  dashboard() {
    //if logged in successfully, go to the dashboard
    if (this.user) {
      this.router.navigate(["/dashboard"]);
    }
  }

  //log the user out
  logout() {
    this.auth.logout();
  }

}
